module.exports = __webpack_public_path__ + "static/media/event-disabled.7811f58e.png";